import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceBaseComponent } from './maintenance-base.component';
import { ContentBaseComponent } from '../../shared/content/content/content-base.component';


@NgModule({
  declarations: [
    MaintenanceBaseComponent,
  ],
  imports: [
    CommonModule,
    ContentBaseComponent,
  ],
  exports: [

  ]
})
export class MaintenanceBaseModule { }
